import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class DaDailyReportService extends GeneratedBizBase{
  async save(dto: ReportDTO,building: string): Promise<Response<ReportDTO>> {
    return super.restCall<Response<ReportDTO>>('post', '/v1/DaDailyReportService/save', arguments);
  }
  async getReportsForPrint(class_ids: string[]): Promise<Response<ReportDTO[]>> {
    return super.restCall<Response<ReportDTO[]>>('get', '/v1/DaDailyReportService/getReportsForPrint', arguments);
  }
  async hasAnySupportPlanForNewReport(class_id: string): Promise<Response<boolean>> {
    return super.restCall<Response<boolean>>('get', '/v1/DaDailyReportService/hasAnySupportPlanForNewReport', arguments);
  }
}
